import httpClient from "../API/HttpClient";

const login = (UserName, Password) =>
  httpClient.post(`login`, { UserName, Password });
  
const GetDivid = (Seq, year) =>
  httpClient.get(`GetDivid?Seq=${Seq}&year=${year}`);
const GetIdentity = (Seq) => httpClient.get(`Getidentity?Seq=${Seq}`);
const GetContact = (Seq) => httpClient.get(`GetContact?Seq=${Seq}`);
const GetBankInfo = (Seq) => httpClient.get(`GetBankInfo?Seq=${Seq}`);
const GetDivid2 = (Seq) => httpClient.get(`GetDivid2?Seq=${Seq}`);
const GetOstan = () => httpClient.get(`GetOstan`);
const GetCity = (id) => httpClient.get(`GetCity?id=${id}`);
const GetBanks = () => httpClient.get(`GetBanks`);
const UpdateIdentity = (Identity) =>
  httpClient.post(`UpdateIdentity`, Identity);
const UpdateContact = (Contact) => httpClient.post(`UpdateContact`, Contact);
const UpdateBank = (Bank) => httpClient.post(`UpdateBank`, Bank);
const ConfirmTick = (sendtick) => httpClient.post(`ConfirmTick`, sendtick);
const ChangePassword = (login) => httpClient.post(`ChangePassword`, login);
const ForgotPassword = (user) => httpClient.post(`ForgotPassword`, user);

export {
  login,
  GetDivid,
  GetIdentity,
  GetContact,
  GetBankInfo,
  GetOstan,
  GetCity,
  GetBanks,
  UpdateIdentity,
  UpdateContact,
  UpdateBank,
  ConfirmTick,
  ChangePassword,
  ForgotPassword,
  GetDivid2,
};
